import * as React from "react";
import { Typography } from "@progress/kendo-react-common";
import StopDataGrid from "./StopDataGrid";
import { FtlRoutingViewModel } from "../../../../ViewModel/FtlRoutingViewModel";
import { ReadOnlyProps } from "../../../ReadOnlyProps";

type Props = {
  routingTable: Array<FtlRoutingViewModel> | undefined;
  routeId: number | undefined;
};

export const StopDataCard = ({ routingTable, routeId, isReadOnly }: Props & ReadOnlyProps) => (
  <div style={{ marginBottom: "2rem" }}>
    {/* eslint-disable-next-line react/jsx-pascal-case */}
    <Typography.h4>Stop Data</Typography.h4>
    <StopDataGrid routings={routingTable ?? []} routeId={routeId ?? 0} isReadOnly={isReadOnly} />
  </div>
);
